export const LISTINGS_FILTER_TOGGLE_VALUE = 'true'

export const LISTINGS_EXTRA_FILTERS = { archived: false }
